import { FOOTBALL_LALIGA } from '@sorare/core/src/constants/__generated__/routes';
import { Navigate } from '@sorare/core/src/routing/Navigate';

const LaLigaSantanderPage = () => {
  return <Navigate to={FOOTBALL_LALIGA} />;
};
export default LaLigaSantanderPage;
